import LeadershipList from "./LeadershipList";

const ExecutiveLeadership = ({
}) => {
    return <LeadershipList type="executive_leadership"/>;
}
export default ExecutiveLeadership;